import {
  Box,
  Card,
  Dialog,
  DialogContent,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@material-ui/core";
import HeadTable from "../common/sortTable/sortTable";
import React, { useEffect, useState } from "react";
import StaffUsersListTittle from "../common/listTitles/StaffUsersListTitle";
import { getFieldByTitle } from "../../helpers/sortByTitle";
import TablesSearch from "../common/tablesSearch/tablesSearch";
import DiscountFilter from "../fixedOdds/DiscountFilter";
import DeleteForeverIcon from "@material-ui/icons/DeleteForever";
import {
  EditButton,
  ShowButton,
  useDataProvider,
  useNotify,
  usePermissions,
} from "react-admin";
import { StaffUser } from "../../types/staffUser";
import RemoveItem from "../common/Remove/RemoveItem";
import PaginationTable from "../common/paginationTable";
import CreditFilter from "../users/CreditFilter";
import { checkPermission } from "../../helpers/checkPermissions";

const StaffUsersList = () => {
  const dataProvider = useDataProvider();
  const { permissions } = usePermissions()
  const notify = useNotify();
  const [state, setState] = useState({
    users: Array<StaffUser>(),
    total: 0,
    page: 1,
    perPage: 10,
    field: "_id",
    order: "asc",
  });

  const [dropdown, setDropdown] = useState({
    first: false,
    last: false,
    email: false,
    role: false,
    status: false,
  });
  const [searchState, setSearchState] = useState({
    name: "",
    surname: "",
    email: "",
  });
  const [filter, setFilter] = useState({
    blocked: "all",
    searchField: '',
    searchRoles: Array<string>(),
  });

  const [blockedFilter, setBlockedFilter] = useState({
    with: false,
    without: false,
  });

  const [modal, setModal] = useState({
    showModal: false,
    id: "",
  });

  useEffect(() => {
    getUsers("all", 1, 10, "_id", "asc", "", "", "", []);
  }, []);

  const getUsers = async (
    blocked: string,
    page: number,
    perPage: number,
    field: string,
    order: string,
    searchEmail: string,
    searchName: string,
    searchSurname: string,
    searchRoles: Array<string>
  ) => {
    const users = (await dataProvider.getList("staff", {
      filter: {
        blocked: blocked,
        searchName,
        searchEmail,
        searchSurname,
        searchRoles
      },
      pagination: { page: page, perPage: perPage },
      sort: { field: field, order: order },
    })) as any;
    setState({
      ...state,
      users: users.data,
      total: users.total,
      page: page,
      perPage: perPage,
      field: field,
      order: order,
    });
  };

  const checkBlockedFilter = (event: React.ChangeEvent<HTMLInputElement>) => {
    const discount = blockedFilter;
    discount[event.target.name] = event.target.checked;
    let currentDiscount = "";
    if (
      (discount.with && discount.without) ||
      (!discount.with && !discount.without)
    ) {
      currentDiscount = "all";
    }
    if (discount.with && !discount.without) {
      currentDiscount = "with";
    }
    if (!discount.with && discount.without) {
      currentDiscount = "without";
    }
    setFilter({ ...filter, blocked: currentDiscount });
    setBlockedFilter(discount);
  };

  const applyBlockedFilter = () => {
    let blocked = "";
    if (
      (blockedFilter.with && blockedFilter.without) ||
      (!blockedFilter.with && !blockedFilter.without)
    ) {
      blocked = "all";
    }
    if (blockedFilter.with && !blockedFilter.without) {
      blocked = "with";
    }
    if (!blockedFilter.with && blockedFilter.without) {
      blocked = "without";
    }
    setFilter({ ...filter, blocked: blocked });
    getUsers(
      blocked,
      1,
      state.perPage,
      state.field,
      state.order,
      searchState.email,
      searchState.name,
      searchState.surname,
      filter.searchRoles
    );
  };

  const filterDropdown = (title: string) => {
    const titleArray = title.toLowerCase().split(" ");
    setDropdown({ ...dropdown, [titleArray[0]]: !dropdown[titleArray[0]] });
  };
  const handleSort = (direction: string, title: string) => {
    const field = getFieldByTitle(title);
    getUsers(
      filter.blocked,
      state.page,
      state.perPage,
      field,
      direction,
      searchState.email,
      searchState.name,
      searchState.surname,
      filter.searchRoles,
    );
  };
  const search = (value: string, field: string) => {
    setSearchState({ ...searchState, [field]: value });
  };
  const applySearch = (field: string) => {
    setFilter({ ...filter, searchField: field });
    getUsers(
      filter.blocked,
      1,
      10,
      "_id",
      "asc",
      searchState.email,
      searchState.name,
      searchState.surname,
      filter.searchRoles,
    );
  };
  const clearSearch = (clear: string) => {
    setSearchState({ ...searchState, [clear]: "" });
  };
  const clearDiscountFilter = () => {
    setBlockedFilter({ with: false, without: false });
    setFilter({ ...filter, blocked: "all" });
  };

  const changeStatus = async (user: StaffUser) => {
    user.isBlocked = !user.isBlocked;
    await dataProvider.update("staff", {
      data: user,
      id: user.id,
      previousData: {} as StaffUser,
    });
    getUsers(
      filter.blocked,
      state.page,
      state.perPage,
      state.field,
      state.order,
      searchState.email,
      searchState.name,
      searchState.surname,
      filter.searchRoles
    );
  };

  const closeModal = () => {
    setModal({ ...modal, showModal: false, id: "" });
  };

  const openModal = (id: string) => {
    setModal({ ...modal, showModal: true, id: id });
  };

  const handleLastPage = () => {
    const page = Math.ceil(state.total / state.perPage);
    getUsers(
      filter.blocked,
      page,
      state.perPage,
      state.field,
      state.order,
      searchState.email,
      searchState.name,
      searchState.surname,
      filter.searchRoles
    );
  };

  const handleFirstPage = () => {
    getUsers(
      filter.blocked,
      1,
      state.perPage,
      state.field,
      state.order,
      searchState.email,
      searchState.name,
      searchState.surname,
      filter.searchRoles
    );
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ): void => {
    const perPage = parseInt(event.target.value, 10);
    getUsers(
      filter.blocked,
      1,
      perPage,
      state.field,
      state.order,
      searchState.email,
      searchState.name,
      searchState.surname,
      filter.searchRoles
    );
  };

  const handleChangePage = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ): void => {
    getUsers(
      filter.blocked,
      newPage + 1,
      state.perPage,
      state.field,
      state.order,
      searchState.email,
      searchState.name,
      searchState.surname,
      filter.searchRoles
    );
  };
  const applyFilter = (field: string, conditions: Array<string>) => {
    setFilter({ ...filter, searchRoles: conditions });
    getUsers(
      filter.blocked,
      state.page,
      state.perPage,
      state.field,
      state.order,
      searchState.email,
      searchState.name,
      searchState.surname,
      conditions
    );
  };

  const removeUser = async () => {
    try {
      const result = await dataProvider.delete("staff", {
        id: modal.id,
        previousData: {} as StaffUser,
      });
      if (result.data) {
        closeModal();
        notify("User successfully removed", "info");
        getUsers(
          filter.blocked,
          state.page,
          state.perPage,
          state.field,
          state.order,
          searchState.email,
          searchState.name,
          searchState.surname,
          filter.searchRoles
        );
      }
    } catch (error) {
      notify("User not found", "error");
    }
  };

  const closeFilter = () => {
    setDropdown({
      first: false,
      last: false,
      email: false,
      role: false,
      status: false
    })
  }

  return (
    <>
      <StaffUsersListTittle />
      <Box marginTop="0.5em">
        <Card>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell id="active-table-head">
                    <HeadTable
                      title="First Name"
                      sort={handleSort}
                      filterHandle={filterDropdown}
                    />
                    {dropdown.first && (
                      <TablesSearch
                        search={(event) =>
                          search(event.currentTarget.value, "name")
                        }
                        applySearch={() => applySearch("name")}
                        searchString={searchState.name}
                        clearSearch={() => clearSearch("name")}
                      />
                    )}
                  </TableCell>
                  <TableCell id="active-table-head">
                    <HeadTable
                      title="Last Name"
                      sort={handleSort}
                      filterHandle={filterDropdown}
                    />
                    {dropdown.last && (
                      <TablesSearch
                        search={(event) =>
                          search(event.currentTarget.value, "surname")
                        }
                        applySearch={() => applySearch("surname")}
                        searchString={searchState.surname}
                        clearSearch={() => clearSearch("surname")}
                      />
                    )}
                  </TableCell>
                  <TableCell id="active-table-head">
                    <HeadTable
                      title="Email address"
                      sort={handleSort}
                      filterHandle={filterDropdown}
                    />
                    {dropdown.email && (
                      <TablesSearch
                        search={(event) =>
                          search(event.currentTarget.value, "email")
                        }
                        applySearch={() => applySearch("email")}
                        searchString={searchState.email}
                        clearSearch={() => clearSearch("email")}
                      />
                    )}
                  </TableCell>
                  <TableCell id="active-table-head">
                    <HeadTable
                      title="Role"
                      sort={handleSort}
                      filterHandle={filterDropdown}
                    />
                    {dropdown.role && (
                      <CreditFilter
                        firstCheckboxTitle="Administrator"
                        secondCheckboxTitle="Super Administrator"
                        thirdCheckboxTitle="Moderator"
                        applyFilter={applyFilter}
                        field="role"
                      />
                    )}
                  </TableCell>
                  <TableCell id="status-table-head-actions">
                    <HeadTable
                      title="Status"
                      sort={handleSort}
                      filterHandle={filterDropdown}
                    />
                    {dropdown.status && (
                      <DiscountFilter
                        checkDiscountFilter={checkBlockedFilter}
                        applyFilter={applyBlockedFilter}
                        clearSelectedItem={clearDiscountFilter}
                        withDiscount={blockedFilter.with}
                        withoutDiscount={blockedFilter.without}
                        firstCheckboxTitle="block"
                        secondCheckboxTitle="active"
                      />
                    )}
                  </TableCell>
                  <TableCell id="active-table-head-actions">Actions</TableCell>
                </TableRow>
              </TableHead>
              {state.users.map((item) => {
                return (
                  <TableBody
                    key={item.email}
                    className={item._id === modal.id ? "mark-user-row" : ""}
                    onClick={closeFilter}
                  >
                    <TableRow>
                      <TableCell>{item.name}</TableCell>
                      <TableCell>{item.surname}</TableCell>
                      <TableCell>{item.email}</TableCell>
                      <TableCell>{item.role}</TableCell>
                      <TableCell>
                        <Box display="flex" justifyContent="center">
                          <label className="switch">
                            <input
                              type="checkbox"
                              checked={!item.isBlocked}
                              onChange={checkPermission(permissions, "Staff management", "Update")?() => changeStatus(item): undefined}
                            />
                            <span className="slider round"></span>
                          </label>
                        </Box>
                      </TableCell>
                      <TableCell>
                        <div className="actions-table-body">
                          {
                            checkPermission(permissions, "Staff management", "View") &&
                            <ShowButton
                              to={`staffUsers/${item.id}/show`}
                            />
                          }
                          {
                            checkPermission(permissions, "Staff management", "Update") &&
                            <EditButton
                              to={`staffUsers/${item.id}`}
                              className="edit-prize"
                            />
                          }
                          {
                            checkPermission(permissions, "Staff management", "Delete") &&
                            <div onClick={() => openModal(item.id!)}>
                              <DeleteForeverIcon className="delete-icon" />
                            </div>}
                        </div>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                );
              })}
            </Table>
          </TableContainer>
          <PaginationTable
            page={state.page}
            perPage={state.perPage}
            collectionLength={state.users.length}
            total={state.total}
            handleChangePage={handleChangePage}
            handleLastPage={handleLastPage}
            handleChangeRowsPerPage={handleChangeRowsPerPage}
            handleFirstPage={handleFirstPage}
            title="Staff users"
          />
          <Dialog fullWidth open={modal.showModal} onClose={closeModal}>
            <DialogContent>
              <RemoveItem closeModal={closeModal} removeUser={removeUser} mainText="staff" minorText="" />
            </DialogContent>
          </Dialog>
        </Card>
      </Box>
    </>
  );
};

export default StaffUsersList;
